import React from 'react'
import { hashHistory, IndexRedirect, IndexRoute, Route, Router } from 'react-router'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { syncHistoryWithStore } from 'react-router-redux'
import AdministrationApp from './administration/components/AdministrationApp'
import AccountInformationsPanel from './administration/components/accountInformations/AccountInformationsPanel'
import MapInformationsPanel from './administration/components/mapInformations/MapInformationsPanel'
import ThemeInformationPanel from './administration/components/themeinformation/ThemeInformationPanel'
import AppStore from './store/AppStore'
import fr from '../public/i18n/properties_fr.json'
import en from '../public/i18n/properties_en.json'
import all from '../public/i18n/properties.json'
import i18n from 'simple-react-i18n'
import DetailStationApp from './station/components/DetailStationApp'
import {
	PATH_ADMINISTRATION,
	PATH_ADMINISTRATION_ACCOUNT,
	PATH_ADMINISTRATION_CREDIT,
	PATH_ADMINISTRATION_MAP,
	PATH_ADMINISTRATION_THEME,
	PATH_HOME,
	PATH_INIT_ACCOUNT,
	PATH_FIND_EMAIL,
	PATH_RESET_PWD,
	PATH_LOGIN,
	PATH_MAIN,
	PATH_POINT_ID,
	PATH_RESEARCH,
	PATH_SELECTION,
	PATH_SIGNUP,
	PATH_STATION
} from './home/constants/HomeConstants'
import DashboardApp from './dashboard/components/DashboardApp'
import SelectionApp from './dashboard/components/selections/SelectionApp'

import CreditInformationPanel from './administration/components/creditinformation/CreditInformationPanel'
import PointApp from './point/components/PointApp'
import AquadbApp from './home/components/AquadbApp'
import MainApp from './home/components/MainApp'
import { getPageViewAnalytics } from './utils/cookie/CookieUtils'
import SitesApp from './sites/components/SitesApp'
import SignUpValidationApp from './signup/components/SignUpValidationApp'
import InitPasswordApp from './initPassword/components/InitPasswordApp'
import LoginApp from './login/components/LoginApp'
import FindPasswordApp from './findPassword/components/FindPasswordApp'
import ResetPasswordApp from './resetPassword/components/ResetPasswordApp'

i18n.addLang(fr, ['fr', 'FR'])
i18n.addLang(en, ['en', 'EN'])
i18n.addLang(all, 'default')
i18n.init()

const history = syncHistoryWithStore(hashHistory, AppStore)
render(
	<Provider store={ AppStore }>
		<Router history={ history } onUpdate={ () => getPageViewAnalytics(window.location.hash) }>
			<Route path={ PATH_HOME } component={ AquadbApp }>
				<IndexRedirect to={ PATH_MAIN }/>
				<Route path={ PATH_MAIN } component={ MainApp }>
					<IndexRoute component={ DashboardApp }/>
					<Route path={ PATH_SELECTION } component={ SelectionApp }/>
				</Route>
				<Route path={ PATH_STATION } component={ DetailStationApp }/>
				<Route path={ PATH_POINT_ID } component={ PointApp }/>
				<Route path={ PATH_ADMINISTRATION } component={ AdministrationApp }>
					<IndexRedirect to={ PATH_ADMINISTRATION_ACCOUNT }/>
					<Route path={ PATH_ADMINISTRATION_ACCOUNT } component={ AccountInformationsPanel }/>
					<Route path={ PATH_ADMINISTRATION_MAP } component={ MapInformationsPanel }/>
					<Route path={ PATH_ADMINISTRATION_THEME } component={ ThemeInformationPanel }/>
					<Route path={ PATH_ADMINISTRATION_CREDIT } component={ CreditInformationPanel }/>
				</Route>
				<Route path={ PATH_RESEARCH } component={ SitesApp }/>
				<Route path={ `${ PATH_RESEARCH }/:isOpen` } component={ SitesApp }/>
			</Route>
			<Route path={ PATH_LOGIN } component={ LoginApp }/> 
			<Route path={ PATH_FIND_EMAIL } component={ FindPasswordApp }/> 
			<Route path={ PATH_RESET_PWD } component={ ResetPasswordApp }/> 
			<Route path={ PATH_SIGNUP } component={ SignUpValidationApp }/>
			<Route path={ PATH_INIT_ACCOUNT } component={ InitPasswordApp }/>
		</Router>
	</Provider>,
	document.getElementById('app')
)



// WEBPACK FOOTER //
// ./src/index.js